import { CommonModule } from '@angular/common';
import { Component, inject, input, signal, ViewChild } from '@angular/core';
import { ContentFooterComponent } from '@ui/content-footer/content-footer.component';
import { ModalService } from '@ui/modal/modal.service';
import { FinalAuthModalComponent } from './final-auth-modal/final-auth-modal.component';
import { IntroAuthModalComponent } from './intro-auth-modal/intro-auth-modal.component';
import {
	SelectionAuthModalComponent,
	EmailProvider,
} from './selection-auth-modal/selection-auth-modal.component';

@Component({
	selector: 'app-auth-modal',
	templateUrl: './auth-modal.component.html',
	imports: [
		IntroAuthModalComponent,
		SelectionAuthModalComponent,
		FinalAuthModalComponent,
		CommonModule,
		ContentFooterComponent,
	],
	standalone: true,
})
export class AuthModalComponent {
	initialStep = input<'intro' | 'selection' | 'final'>('intro');
	step_ = signal<'intro' | 'selection' | 'final'>(this.initialStep());
	selectedProvider = signal<EmailProvider>(null);

	@ViewChild(SelectionAuthModalComponent)
	selectionComponent!: SelectionAuthModalComponent;

	modalService = inject(ModalService);

	onStepChange(step: 'intro' | 'selection' | 'final') {
		this.step_.set(step);
	}

	onProviderSelected(provider: EmailProvider) {
		this.selectedProvider.set(provider);
	}

	onNext = () => {
		const currentStep = this.step_();
		if (currentStep === 'intro') {
			this.step_.set('selection');
		} else if (currentStep === 'selection') {
			const provider = this.selectedProvider();
			if (provider && this.selectionComponent) {
				this.selectionComponent.startOAuthFlow(provider);
			} else {
				console.warn('No email provider selected');
			}
		}
	};

	onBack = () => {
		const currentStep = this.step_();
		if (currentStep === 'selection') {
			this.step_.set('intro');
		} else if (currentStep === 'final') {
			this.step_.set('selection');
		}
	};

	get isNextDisabled(): boolean {
		const currentStep = this.step_();
		return currentStep === 'selection' && !this.selectedProvider();
	}
}
